export const QUERY_KEY_BLOCKS = 'blocks';
